import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f65b90ea&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/app/appsumo/nuxt/components/common/Loader.vue').default,MobileDealBannerHeader: require('/app/appsumo/nuxt/components/pdp/MobileDealBannerHeader.vue').default,Breadcrumbs: require('/app/appsumo/nuxt/components/pdp/Breadcrumbs.vue').default,PDPDealStory: require('/app/appsumo/nuxt/components/pdp/PDPDealStory.vue').default,PDPSectionTabs: require('/app/appsumo/nuxt/components/pdp/PDPSectionTabs.vue').default,EmbeddedSmartCollection: require('/app/appsumo/nuxt/components/smartcollections/EmbeddedSmartCollection.vue').default,DealTermsAndFeatures: require('/app/appsumo/nuxt/components/products/terms-and-features/DealTermsAndFeatures.vue').default,PricingTable: require('/app/appsumo/nuxt/components/products/pricing-table/PricingTable.vue').default,ProductsFounders: require('/app/appsumo/nuxt/components/products/founders/ProductsFounders.vue').default,PDPDiscussion: require('/app/appsumo/nuxt/components/pdp/discussion/PDPDiscussion.vue').default,SignUpBanner: require('/app/appsumo/nuxt/components/common/SignUpBanner.vue').default,PDPMainContainer: require('/app/appsumo/nuxt/components/pdp/PDPMainContainer.vue').default})
